// extracted by mini-css-extract-plugin
export var currencyInput = "_nh-1";
export var currencySymbol = "_nh-0";